var React = require('react');

function Codepen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 0C10.7 0 0 10.8 0 24s10.7 24 24 24 24-10.8 24-24S37.3 0 24 0zm0 44.1c-11.1 0-20.1-9-20.1-20.1 0-11.1 9-20 20.1-20 11.1 0 20.1 9 20.1 20.1 0 11-9 19.9-20.1 20zm14.8-25.2L24 9 9.1 18.9V29L24 39l14.8-9.8V18.9zm-3.5.6l-4.5 3-5.5-3.7v-6l10 6.7zm-12.6-.7l-5.5 3.7-4.5-3 10-6.7v6zm-11 3.1l3.2 2.1-3.2 2.1v-4.2zm11 13.3l-10-6.6 4.5-3 5.5 3.7v5.9zM24 27l-4.5-3 4.5-3 4.5 3-4.5 3zm1.3 2.2l5.5-3.7 4.5 3-10 6.6v-5.9zm7.8-5.2l3.2-2.1v4.3L33.1 24z"}));
}

Codepen.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Codepen;

Codepen.default = Codepen;
